<div class="page-container">
    <app-header
        title="{{ 'change-requests.people' | translate }}"
        [menuService]="employeeModuleMenuService"
    ></app-header>
    <app-table [table]="table" [title]="'change-requests.logTableTitle' | translate" [showSearch]="false">
        <app-empty-state
            label="change-requests.noChangeRequestsFound"
            src="/assets/illustrations/magnifying-glass.png"
        ></app-empty-state>
    </app-table>
</div>
